/*eslint-disable*/export const messages=JSON.parse("{\"forms.field.label.optional\":[\"(valgfritt)\"],\"forms.validation.mandatoryField\":[\"Må fylles ut\"]}");